
document.addEventListener('click', function(event) {
  var trigger = event.target.closest('a[href="#shopifyReshowConsentBanner"]');
  if (!trigger) return;
  event.preventDefault();
  event.stopImmediatePropagation();
  function openPreferences() {
    if (window.privacyBanner && typeof window.privacyBanner.showPreferences === 'function') {
      return window.privacyBanner.showPreferences();
    }
    return Promise.reject(new Error('Cookie preferences are unavailable'));
  }
  if (window.privacyBanner) {
    openPreferences().catch(function() { window.location.assign('/pages/your-privacy-choices'); });
    return;
  }
  var script = document.createElement('script');
  script.src = 'https://cdn.shopify.com/shopifycloud/privacy-banner/storefront-banner.js';
  script.onload = function() { openPreferences().catch(function() { window.location.assign('/pages/your-privacy-choices'); }); };
  script.onerror = function() { window.location.assign('/pages/your-privacy-choices'); };
  document.head.appendChild(script);
}, true);
